export default __webpack_public_path__ + "static/media/icon_6.ba2a346c.svg";